import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import './LanguageSwitcher.css';

const LanguageSwitcher = () => {
    const { language, toggleLanguage } = useLanguage();

    return (
        <button className="language-switcher-btn" onClick={toggleLanguage}>
            {language === 'tr' ? '🇬🇧 EN' : '🇹🇷 TR'}
        </button>
    );
};

export default LanguageSwitcher;
